"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formCoupler = exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _assign2 = _interopRequireDefault(require("lodash/assign"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _reactBeautifulDnd = require("react-beautiful-dnd");
var _cccisdApollo = require("cccisd-apollo");
var _cccisdFormik = require("cccisd-formik");
var _arrowResize = _interopRequireDefault(require("cccisd-icons/arrow-resize4"));
var _cancelCircle = _interopRequireDefault(require("cccisd-icons/cancel-circle2"));
var _info = _interopRequireDefault(require("cccisd-icons/info2"));
var _question = _interopRequireDefault(require("cccisd-icons/question4"));
var _warning = _interopRequireDefault(require("cccisd-icons/warning2"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _deployments = _interopRequireDefault(require("./deployments.graphql"));
var _EditDeployment = _interopRequireDefault(require("./EditDeployment"));
var _navigations = require("../../../navigations");
var _ImagePicker = _interopRequireDefault(require("../../ImagePicker"));
var _helpers = require("../../helpers");
var _style = _interopRequireDefault(require("./style.css"));
var _SurveySelector = _interopRequireDefault(require("../SurveySelector"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var initialValues = {
  isCurriculum: false,
  toggle: true,
  tabName: 'Course',
  navigation: 'noSidebar',
  options: [],
  curriculumOptions: [],
  allowRetake: true
};
var validate = function validate(values, errors) {
  var localErrors = {};
  if (values.course.toggle) {
    if (!values.course.tabName) {
      localErrors['course.tabName'] = 'Course Tab Name is required';
    }
    if (values.course.isCurriculum) {
      if (!values.course.navigation.startsWith('curriculum')) {
        localErrors['course.navigation'] = 'You must select a curriculum navigation style';
      }
      if (!values.course.curriculumOptions.length) {
        localErrors['course.curriculumOptions'] = 'You must select at least one deployment';
      }
    } else {
      if (!values.course.navigation || values.course.navigation.startsWith('curriculum')) {
        localErrors['course.navigation'] = 'You must select a navigation style';
      }
      if (values.course.options.length === 0) {
        localErrors['course.options'] = 'You must select at least one Course survey';
      }
    }
  }
  (0, _assign2["default"])(errors, localErrors);
  return !Object.keys(localErrors).length;
};
var formCoupler = exports.formCoupler = {
  initialValues: initialValues,
  validate: validate,
  errorTab: 'course',
  key: 'course'
};

/* Main Component */
var FormCourse = function FormCourse(_ref) {
  var assignmentData = _ref.assignmentData,
    formProps = _ref.formProps;
  var _useState = (0, _react.useState)(true),
    _useState2 = _slicedToArray(_useState, 2),
    isLoadingDeployments = _useState2[0],
    setIsLoadingDeployments = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    deploymentList = _useState4[0],
    setDeploymentList = _useState4[1];
  var questSettings = assignmentData.settings,
    currentSurveylistList = assignmentData.currentSurveylistList,
    projectId = assignmentData.groupId,
    assignmentId = assignmentData.assignmentId;
  var isCurriculum = (0, _get2["default"])(formProps, 'values.course.isCurriculum', false);
  (0, _react.useEffect)(function () {
    function getDeploymentList() {
      return _getDeploymentList.apply(this, arguments);
    }
    function _getDeploymentList() {
      _getDeploymentList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var resp, deployments;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              setIsLoadingDeployments(true);
              _context.n = 1;
              return _cccisdApollo.client.query({
                query: _deployments["default"],
                variables: {
                  projectId: projectId,
                  assignmentId: assignmentId
                },
                fetchPolicy: 'network-only'
              });
            case 1:
              resp = _context.v;
              deployments = (0, _get2["default"])(resp, 'data.flows.deploymentList', []) || [];
              deployments.forEach(function (d) {
                delete d.__typename;
                delete d.assignment.__typename;
              });
              setDeploymentList(deployments);
              setIsLoadingDeployments(false);
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      return _getDeploymentList.apply(this, arguments);
    }
    getDeploymentList();
  }, [isCurriculum]);
  function renderCurriculumDeploymentSelector() {
    if (deploymentList.length <= 0) {
      return /*#__PURE__*/_react["default"].createElement("p", {
        className: 'text-muted ' + _style["default"].noDeploymentMessage
      }, "There are no deployments to choose from.\xA0", /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: "You must create Deployments for other Quests within this Quest Project"
      }, /*#__PURE__*/_react["default"].createElement(_question["default"], null)));
    }
    return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.FieldArray, {
      name: "course.curriculumOptions"
    }, function (arrayHelpers) {
      var currVal = (0, _get2["default"])(arrayHelpers, 'form.values.course.curriculumOptions', []) || [];
      var errorMsg = arrayHelpers.form.submitCount > 0 && arrayHelpers.form.errors['course.curriculumOptions'];
      var handleAddDeployment = function handleAddDeployment(event) {
        var val = event.currentTarget.value;
        if (!val) {
          return;
        }
        arrayHelpers.push({
          deploymentId: Number(val)
        });
      };
      var handleDragEnd = function handleDragEnd(result) {
        arrayHelpers.move(result.source.index, result.destination.index);
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "alert alert-info"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: 'mb-3 ' + (errorMsg ? 'is-invalid' : '')
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "form-label",
        htmlFor: "newCurriculumOption"
      }, "Selected Deployments", ' ', /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: 'Deployments will be shown in the order they appear below.' + ' Use the drag-n-drop to reorder them.'
      }, /*#__PURE__*/_react["default"].createElement(_info["default"], null))), /*#__PURE__*/_react["default"].createElement("select", {
        className: 'form-select ' + _style["default"].deploymentSelect,
        id: "newCurriculumOption",
        value: "",
        onChange: handleAddDeployment,
        disabled: isLoadingDeployments
      }, /*#__PURE__*/_react["default"].createElement("option", null, "-- choose deployment to add --"), deploymentList.filter(function (d) {
        return !currVal.some(function (selectedDeployment) {
          return selectedDeployment.deploymentId === d.deploymentId;
        });
      }).map(function (d) {
        return /*#__PURE__*/_react["default"].createElement("option", {
          value: d.deploymentId,
          key: d.deploymentId
        }, d.assignment.label, " (", d.label, ")");
      }))), currVal.length === 0 ? /*#__PURE__*/_react["default"].createElement("p", {
        className: _style["default"].noDeploymentsMsg
      }, "No Deployments have been added yet") : /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.DragDropContext, {
        onDragEnd: handleDragEnd
      }, /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.Droppable, {
        droppableId: "course-curriculumOptions-droppable"
      }, function (provided, snapshot) {
        return /*#__PURE__*/_react["default"].createElement("div", _extends({}, provided.droppableProps, {
          ref: provided.innerRef
        }), currVal.map(function (deployment, i) {
          return renderDraggable(deployment, i, arrayHelpers);
        }), provided.placeholder);
      })), errorMsg && /*#__PURE__*/_react["default"].createElement("p", {
        className: "text-danger"
      }, errorMsg));
    });
  }
  function renderDraggable(_ref2, index, arrayHelpers) {
    var deploymentId = _ref2.deploymentId;
    var deployment = deploymentList.find(function (d) {
      return Number(d.deploymentId) === Number(deploymentId);
    });
    var deleteButton = /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
      title: "Remove"
    }, /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "btn btn-xs btn-danger",
      onClick: function onClick() {
        return arrayHelpers.remove(index);
      }
    }, /*#__PURE__*/_react["default"].createElement(_cancelCircle["default"], null)));
    if (!deployment) {
      return /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.Draggable, {
        key: deploymentId + index,
        draggableId: deploymentId + index + '',
        index: index
      }, function (provided) {
        return /*#__PURE__*/_react["default"].createElement("div", _extends({
          ref: provided.innerRef
        }, provided.draggableProps, provided.dragHandleProps, {
          className: "".concat(_style["default"].draggable, " ").concat(isAnon ? _style["default"].warningMessage : '')
        }), /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_arrowResize["default"], null)), /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("p", {
          className: "text-warning"
        }, /*#__PURE__*/_react["default"].createElement(_warning["default"], null), "\xA0\xA0Deployment with ID ", deploymentId, " is not found. It may have been deleted after it was added. It is recommended to delete this selected deployment or contact a developer.")), /*#__PURE__*/_react["default"].createElement("span", null, deleteButton));
      });
    }
    var displayName = (0, _get2["default"])(arrayHelpers, "form.values.course.curriculumOptions.".concat(index, ".displayName"), null);
    var isAnon = deployment.type === 'anon';
    return /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.Draggable, {
      key: deployment.deploymentId,
      draggableId: deployment.deploymentId + '',
      index: index
    }, function (provided) {
      return /*#__PURE__*/_react["default"].createElement("div", _extends({
        ref: provided.innerRef
      }, provided.draggableProps, provided.dragHandleProps, {
        className: "".concat(_style["default"].draggable, " ").concat(isAnon ? _style["default"].warningMessage : '')
      }), /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_arrowResize["default"], null)), /*#__PURE__*/_react["default"].createElement("span", null, deployment.assignment.label, " (", deployment.label, ")", displayName && /*#__PURE__*/_react["default"].createElement("p", {
        className: _style["default"].displayName
      }, /*#__PURE__*/_react["default"].createElement("b", null, "Assignment Display Name:"), " ", displayName), isAnon && /*#__PURE__*/_react["default"].createElement("p", {
        className: "text-warning"
      }, /*#__PURE__*/_react["default"].createElement(_warning["default"], null), "\xA0\xA0This deployment has respondent type \"anonymous\". Usually \"managed\" or \"known\" is required in order to save user progress.")), /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_EditDeployment["default"], {
        deployment: deployment,
        index: index,
        arrayHelpers: arrayHelpers
      }), deleteButton));
    });
  }
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("h3", null, "Course"), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'none'
    }
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "course.toggle",
    component: _cccisdFormik.CccisdToggle,
    label: "Use Course Tab"
  })), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "course.tabName",
    component: _cccisdFormik.CccisdInput,
    label: /*#__PURE__*/_react["default"].createElement(_helpers.LabelWithTooltip, {
      label: "Course Tab Name",
      tooltip: "The text for Course in the tab bar"
    })
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "course.isCurriculum",
    component: _cccisdFormik.CccisdToggle,
    label: /*#__PURE__*/_react["default"].createElement(_helpers.LabelWithTooltip, {
      label: "Use Curriculum Navigation",
      tooltip: 'If using Curriculum navigation, or "course of courses", ' + 'you must select separate Quests that will play in the Course tab. '
    })
  }), isCurriculum ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "course.curriculumTabStyle",
    component: _cccisdFormik.CccisdSelect,
    style: {
      width: 'auto'
    },
    options: [{
      value: 'default',
      label: 'Default Tabs'
    }, {
      value: 'side',
      label: 'Side Tabs'
    }],
    label: /*#__PURE__*/_react["default"].createElement(_helpers.LabelWithTooltip, {
      label: "Tab Navigation Style",
      tooltip: /*#__PURE__*/_react["default"].createElement("ul", {
        className: _style["default"].tabStyleTooltip
      }, /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("b", null, "Default Tabs"), " is the normal Course Wrapper navigation, with tabs at the top of the page."), /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("b", null, "Side Tabs"), " shows the Course Wrapper navigation tabs in a collapsable tab on the left side of the screen. This option may be better to optimize the course for vertical space or mobile devices."))
    })
  }), renderCurriculumDeploymentSelector()) : /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "course.options",
    label: /*#__PURE__*/_react["default"].createElement(_helpers.LabelWithTooltip, {
      label: "Course Surveys",
      tooltip: "Select the survey(s) representing the Course."
    }),
    component: _SurveySelector["default"],
    surveyList: currentSurveylistList.surveyList
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "alert alert-info",
    style: {
      paddingBottom: 0
    }
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "course.navigation",
    label: "Navigation for Course",
    component: _ImagePicker["default"],
    options: (0, _navigations.getNavigations)({
      noCourseWrapper: true,
      requiredNavigation: (0, _get2["default"])(formProps, 'initialValues.course.navigation')
    }).filter(function (nav) {
      return isCurriculum ? nav.handle.startsWith('curriculum') : !nav.handle.startsWith('curriculum');
    }),
    questSettings: questSettings,
    height: "98px",
    settingsFieldName: "course.navigationSettings"
  })), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "course.allowRetake",
    component: _cccisdFormik.CccisdToggle,
    label: /*#__PURE__*/_react["default"].createElement(_helpers.LabelWithTooltip, {
      label: "Should respondents be allowed to edit their answers after submitting?",
      tooltip: "If no, the course will not be accessible after completion."
    })
  }));
};
var _default = exports["default"] = FormCourse;